import { render, staticRenderFns } from "./DC_ZH_1F.vue?vue&type=template&id=18493353&scoped=true"
import script from "./DC_ZH_1F.vue?vue&type=script&lang=js"
export * from "./DC_ZH_1F.vue?vue&type=script&lang=js"
import style0 from "./DC_ZH_1F.vue?vue&type=style&index=0&id=18493353&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18493353",
  null
  
)

export default component.exports